import pulse from '@finn-no/pulse-sdk';
import { Action } from '../common.js';
import { EventData } from './consent-context.js';
import type { UIElement } from '@finn-no/pulse-sdk/dist/types.js';

function nameMapper(consentName: string): EventData {
    switch (consentName) {
        case 'nyhetsbrev-fra-finn':
            return {
                eventName: 'Newsletter subscription',
                accept: 'Subscribe',
                reject: 'Unsubscribe',
            };
        case 'tilpasset-innhold':
            return {
                eventName: 'Personalise FINN',
                accept: 'Accept',
                reject: 'Reject',
            };
        case 'viktig-informasjon-fra-finn':
            return {
                eventName: 'Notifications: general',
                accept: 'Subscribe',
                reject: 'Unsubscribe',
            };
        default:
            return {
                eventName: consentName,
                accept: 'Accept',
                reject: 'Reject',
            };
    }
}

export function onGDPRTakeout() {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'GDPR takeout',
        target: {
            id: 'gdpr-takeout',
            referralCommission: false,
            provider: 'Schibsted',
            name: 'Go to website',
            type: 'ExternalContent',
        },
        object: {
            id: 'userprofilepage:privacy:ua_pv02',
            type: 'UIElement',
            elementType: 'Button',
        } as UIElement,
        vertical: {
            name: 'common_pages',
            subVertical: 'profile',
        },
    });
}

export function onDeleteUserPopup() {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Delete Finn user popup',
        target: {
            id: 'delete-user-popup',
            referralCommission: false,
            provider: 'Schibsted',
            name: 'Go to website',
            type: 'ExternalContent',
        },
        object: {
            id: 'userprofilepage:privacy:ua_pv02',
            type: 'UIElement',
            elementType: 'Button',
        },
        vertical: {
            name: 'common_pages',
            subVertical: 'profile',
        },
    });
}

export function onDeleteUser() {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Delete Finn user',
        target: {
            id: 'delete-user',
            referralCommission: false,
            provider: 'Schibsted',
            name: 'Go to website',
            type: 'ExternalContent',
        },
        object: {
            id: 'userprofilepage:privacy:ua_pv02',
            type: 'UIElement',
            elementType: 'Button',
        },
        vertical: {
            name: 'common_pages',
            subVertical: 'profile',
        },
    });
}

function trackUpdate(eventData: EventData, action: Action) {
    if (eventData) {
        const eventAction = (() => {
            switch (action) {
                case Action.ACCEPTED:
                    return eventData.accept;
                case Action.WITHDRAWN:
                    return eventData.reject;
            }
        })();

        pulse.trackEvent({
            type: 'Click',
            intent: eventAction,
            name: eventData.eventName,
            object: {
                id: 'userprofilepage:privacy:ua_pv02',
                type: 'UIElement',
                elementType: 'Checkbox',
                url: 'https://www.finn.no/privacy',
            },
            vertical: {
                name: 'common_pages',
                subVertical: 'profile',
            },
        });
    }
}

export function trackUpdateConsent(consent: GivenConsent, action: Action) {
    const eventData = nameMapper(consent.userConsent.name);
    trackUpdate(eventData, action);
}

export function trackUpdateLegitimateInterest(
    legitimateInterestForUser: LegitimateInterestForUser,
    action: Action,
) {
    const eventData = nameMapper(legitimateInterestForUser.purpose.name);
    trackUpdate(eventData, action);
}
